import React, { useEffect, useState, useRef } from "react";
import {notification, Select } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { getGeneralData, updateGeneralData }  from  "../../../controllers/V1/generalDataController";
import moment from "moment";
const UserListEditPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ADDEDITDATA, setAddEditSata] = useState({});
  const fields = [
    {type : "text", label : "Analyser Start Time", name:"analyser_start_time", id : "analyser_start_time", placeholder : "Analyser start time", size : "3"},
    {type : "text", label : "Analyser End Time", name:"analyser_end_time", id : "analyser_end_time", placeholder : "Analyser end time", size : "3"},
    {type : "text", label : "Invoice Start Time", name:"invoice_start_time", id : "invoice_start_time", placeholder : "Invoice start time", size : "3"},
    {type : "text", label : "Invoice End Time", name:"invoice_end_time", id : "invoice_end_time", placeholder : "Invoice end time", size : "3"}
  ]

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const params = {
        analyser_start_time   : formData.get('analyser_start_time') || '00:00',
        analyser_end_time     : formData.get('analyser_end_time') || '00:00',
        invoice_start_time    : formData.get('invoice_start_time') || '00:00',
        invoice_end_time      : formData.get('invoice_end_time') || '00:00',
      }

      const res = await updateGeneralData(params);
      if(res?.status === true){
        notification.open({
        message: "Success",
        description: `Data updated successfully.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "green" }} />,
        duration: 2,
      });
      } else{
        notification.open({
          message: "Oops!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
      console.log('params : ', params);
    } catch (error) {
      
    }
  }

  const fetchGeneralData = async () =>{
    try {
      setIsLoading(true);
      const res = await getGeneralData();
      if(res){
        setAddEditSata(res || {});
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchGeneralData();
    document.title = `K-Winn || General Data`;
  }, []);
  
  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> General Data </h5>
          </React.Fragment>
          <Link to={`/dashboard`}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <ArrowLeftOutlined /> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}>
                <div className="row">
                  {(fields && fields?.length > 0) && (fields.map((items)=>(
                    <div className={`form-group col-lg-${items?.size || '3'} col-md-${items?.size || '3'} col-sm-6 col-xs-12 vendor_Add_edit_data`}>
                      <label
                        htmlFor={`${items?.name}`}
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>{items?.label || 'Label'} :{" "}
                      </label>
                      <input
                        type={`${items?.type}`}
                        name={`${items?.name}`}
                        id={`${items?.id}`}
                        value={ADDEDITDATA[`${items?.name}`]}
                        placeholder={`${items?.placeholder}`}
                        className="form-control store_input_field"
                        onChange={handleChange}
                      />
                      {error.start_date ? (
                        <p style={{ color: "red" }}>{error.start_date}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  )))}

                </div>
                <div className="inventory_edit_submit_btn">
                  <button type="submit" className="btn btn-primary inventory_save_button" > Save </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} text={'Fetching data! Please wait...'} />
    </div>
  );
};

export default UserListEditPage;
